import React from 'react';
import FilingStatusSummary from './FilingStatusSummary';
import ReturnStatusIcon from './ReturnStatusIcon';
import Skeleton from '../../../components/library/loaders/Skeleton';
import CollapsibleCardHeader from '../../../components/library/stacking-collapsible-cards/CollapsibleCardHeader';
import FilingStatusRow from './FilingStatusRow';

const SkeletonStatusCard = () => (
    <div className='stackable-section'>
        <CollapsibleCardHeader icon={<ReturnStatusIcon dashboardStatus='IN_PROGRESS' netfileStatus='IN_PROGRESS' />} collapsed>
            <div className='column is-8 pl-0 ml-0'>
                <Skeleton />
            </div>
            <div className='column is-4'>
                <Skeleton />
            </div>
        </CollapsibleCardHeader>
        <FilingStatusSummary collapsed loading />
        <FilingStatusRow submissionType='CRA' loading />
    </div>
)

export default SkeletonStatusCard